import React, {useEffect, useState} from "react"
import {Button, ButtonGroup, SimpleGrid} from "@chakra-ui/react"

import {EmptyState, Loading, PageTitle} from "@components/app"
import {IGame, TGameModes} from "@backend/types"
import {gameApiCalls} from "@modules/game/service"
import {GameCard} from "@modules/game/components"
import {gameModeOptions} from "@modules/game/constants"

function Dashboard() {
    const [games, setGames] = useState<IGame[] | null>()
    const [mode, setMode] = useState<TGameModes | null>()

    useEffect(() => {
        if (!games)
            gameApiCalls.userGames().then(setGames)
    }, [])

    function filterByMode(mode: TGameModes) {
        setMode(mode)
        setGames(null)
        gameApiCalls.userGames(mode).then(setGames)
    }

    return <div>
        <PageTitle
            title="Play a game to help build a smarter legal system"
            subTitle="Choose one of the games below, and get started on rating legal answers or spotting legal issues. Your game play helps build more knowledge about how to provide better legal help to people."
        />
        <div className="flex justify-end border-b mb-10 pb-2">
            <ButtonGroup isAttached variant="outline" colorScheme="blue" size="sm">
                <Button variant={!mode ? "solid" : "outline"} onClick={filterByMode.bind(null, null)}>All Modes</Button>
                {Object.values(gameModeOptions).map(({value, short}) =>
                    <Button key={value}
                            variant={mode === value ? "solid" : "outline"}
                            onClick={filterByMode.bind(null, value)}>{short}</Button>)}
            </ButtonGroup>
        </div>
        {/*<Divider my={10}/>*/}
        <main>
            {games ? (
                    games.length ?
                        <SimpleGrid columns={{sm: 1, md: 2, lg: 3}} spacing="20px">
                            {games.map(game =>
                                <GameCard
                                    key={game._id as string}
                                    to={game.gamePlay?.completeStatus === "finished" ? `/results/${game.gamePlay?._id}` : `/play/${game._id}`}
                                    info={game.info}
                                    gamePlayStatus={game.gamePlay?.completeStatus}
                                />)}
                        </SimpleGrid> :
                        <EmptyState
                            title="No Game Here"
                            description="You can check other game modes for more games"
                        />
                ) :
                <Loading/>
            }
        </main>
    </div>
}

export default Dashboard

